// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__gH7qO","footer":"ModalUpdate_footer__2Ts6q"};